import React from 'react';
import './ProgramGoalTimeline.css';

const ProgramGoalTimeline = ({
  label = 'Målet: 30 min sammenhengende løping',
  className = ''
}) => {
  return (
    <div className={`program-goal-timeline ${className}`.trim()} role="presentation">
      <div className="program-goal-timeline__inner">
        <span className="program-goal-timeline__dot" aria-hidden="true" />
        <span className="program-goal-timeline__segment" aria-hidden="true" />
        <p className="program-goal-timeline__label">{label}</p>
        <span className="program-goal-timeline__segment" aria-hidden="true" />
        <span className="program-goal-timeline__dot" aria-hidden="true" />
      </div>
    </div>
  );
};

export default ProgramGoalTimeline;
